export { default } from './PaletteForm';
